/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-25 10:00:00                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 16:33:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Validator
  * TechnicianForm: Create/edit technician form
*/

/* Imports */
import { t } from "i18next";
/***/

/* Services */
import AddressSelect from "../address/AddressSelect";
import { validator } from "../../../services/form-validator/form-validator";
import { Select, Option } from "@material-tailwind/react";
import Switch from "../../switch/Switch";
/***/

/***/

export const ZoneFormValidator = {
  address: (e: unknown) => validator.isNotNull(e),
  radius: (e: number) => validator.isNumber(e),
  type: (e: string) => e === "A" || e === "B" || e === "C"
};

const v = ZoneFormValidator; // shorthand

/**
* TechnicianForm: Create/edit technician form 
* @param data - Data to edit
* @param onChange - On change event, trigger on field change
* @param onSubmit - On submit event, trigger enter key down on field
* @param submitted - is form submitted
*/
export default function ZoneForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.Zone,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {
      
  return (
    <>
      <AddressSelect  label={`${t("Address")} *`}
                              value={data?.address}
                              className={`form-field ${(submitted && !validator.isFieldValid(data, "address", v)) && "error"}`}
                              onChange={(value) => onChange("address", value)}/>
      <div className="field">
        <label htmlFor="radius">{t("Radius")+" (KM) *"}</label>
        <input type="number"
                value={data?.radius || ""}
                onChange={(e) => onChange("radius", e.target.value)}
                className={`${(submitted && (!data || !data?.radius)) && "error"}`}
                placeholder={t("Radius")}/>
      </div>
      <div className="field">
        <label htmlFor="label">{t("Type")}</label>
        <Select
            value={data?.type}
            onChange={(e) => onChange("type", e)}>
            <Option key={"A"} value={"A"}>{"A"}</Option>
            <Option key={ "B"} value={ "B"}>{ "B"}</Option>
            <Option key={"C"} value={"C"}>{"C"}</Option>
        </Select>
      </div>

      <div className="field">
        <label className="block text-sm font-medium text-gray-700 mb-1">{t("Enable this zone")}</label>
        <Switch checked={data?.enabled}
            onChange={(e) => onChange("enabled", e)}/>
      </div>
    </>
  );
}
/***/
